<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

const route = useRoute();
const { t } = useI18n();

const navigation = computed(() => [
  {
    label: t('AI_REVIEWS.NAV.BATCHES'),
    routeName: 'ai_review_batches',
    activeOn: ['ai_review_batches', 'ai_review_batch_show', 'ai_review_show'],
  },
  {
    label: t('AI_REVIEWS.NAV.START_REVIEW'),
    routeName: 'ai_review_batch_new',
    activeOn: ['ai_review_batch_new'],
  },
  {
    label: t('AI_REVIEWS.NAV.POLICIES'),
    routeName: 'ai_review_policies',
    activeOn: ['ai_review_policies', 'ai_review_policy_show'],
  },
  {
    label: t('AI_REVIEWS.NAV.KNOWLEDGE_BASES'),
    routeName: 'ai_review_knowledge_bases',
    activeOn: ['ai_review_knowledge_bases'],
  },
  {
    label: t('AI_REVIEWS.NAV.MODEL_PROFILES'),
    routeName: 'ai_review_model_profiles',
    activeOn: ['ai_review_model_profiles'],
  },
]);

const routeTarget = routeName => ({
  name: routeName,
  params: { accountId: route.params.accountId },
});
</script>

<template>
  <main
    class="flex flex-col flex-1 min-w-0 h-full overflow-hidden bg-n-background"
  >
    <header class="flex-shrink-0 px-8 pt-6 border-b border-n-weak bg-n-solid-2">
      <div class="mx-auto max-w-7xl">
        <h1 class="mb-1 text-2xl font-semibold text-n-slate-12">
          {{ t('AI_REVIEWS.TITLE') }}
        </h1>
        <p class="mb-5 text-sm text-n-slate-11">
          {{ t('AI_REVIEWS.DESCRIPTION') }}
        </p>
        <nav
          :aria-label="t('AI_REVIEWS.NAV.ARIA_LABEL')"
          class="flex gap-5 overflow-x-auto"
        >
          <RouterLink
            v-for="item in navigation"
            :key="item.routeName"
            :to="routeTarget(item.routeName)"
            class="pb-3 text-sm font-medium whitespace-nowrap border-b-2"
            :class="
              item.activeOn.includes(route.name)
                ? 'text-n-brand border-n-brand'
                : 'text-n-slate-11 border-transparent hover:text-n-slate-12'
            "
          >
            {{ item.label }}
          </RouterLink>
        </nav>
      </div>
    </header>
    <div class="flex-1 min-h-0 px-8 py-6 overflow-y-auto">
      <div class="mx-auto max-w-7xl">
        <RouterView />
      </div>
    </div>
  </main>
</template>
